import ModalCEWarehouse from './ModalCreateWarehouse'
import { WarehouseModelType } from '@teinor/erp/types/company/warehouse'
import { useLocation } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { TwinTableLink } from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderStateName, CustomRenderCountryName, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { getDictionaryCountries } from '../../../../../utils/reducers/getters'
import { getBasePath } from '../../../../../utils/globals/link'


interface WarehousesProps extends ComponentWithPermissions { }

const Warehouses: React.FC<WarehousesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('warehouses', 'Almacenes'),
        newText: t('newWarehouse', 'Nuevo almacén'),
    }

    return (
        <BaseScreenTable TableComponent={TableWarehouses} CreateModalComponent={ModalCEWarehouse} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableWarehousesProps extends TableComponentProps { }

const TableWarehouses: React.FC<TableWarehousesProps> = ({ setTableInstance }) => {
    const { t } = useTwinTranslation()
    const countries = getDictionaryCountries()
    const location = useLocation().pathname
    const columns: ColumnTableSchema<WarehouseModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            minWidth: 130,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'code',
            dataKey: 'code',
            label: t('code', 'Código'),
            sortable: true,
            minWidth: 110
        },
        {
            id: 'address',
            dataKey: 'address',
            label: t('address', 'Dirección'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('address', 'Dirección'), }
            }
        },
        {
            id: 'city',
            dataKey: 'city',
            label: t('city', 'Ciudad'),
            minWidth: 120,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('city', 'Ciudad'), }
            }
        },
        {
            id: 'state',
            dataKey: 'state',
            label: t('state', 'Provincia'),
            customRender: (parameterValue, allRowData) => <CustomRenderStateName stateId={parameterValue} allRowData={allRowData} />,
        },
        {
            id: 'country',
            dataKey: 'country',
            label: t('country', 'País'),
            customRender: (parameterValue) => <CustomRenderCountryName countryId={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: countries, label: t('country', 'País') }
            },
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
    ]
    return (
        <TwinTableLink name='warehouses' columns={columns} createRowDataLink={[getBasePath(location, 'warehouses'), ['$id', 'main']]} getDataFrom='/api/app/warehouse/getAllWarehouses' setTableInstance={setTableInstance} />
    )
}

export default Warehouses